export enum THEME_IDS {
  DEFAULT_THEME = '1000',
  FIRST_THEME = '1001',
  PREMIER_THEME = '1002'
}

export type ThemeConfig = {
  id: THEME_IDS;
  primaryColor: string;
  gradient: string;
  brandHover?: string;
  textBrand2?: string;
  overrides?: ThemeOverrides;
};

export type CssVariables = {
  '--progress-gradient': string;
  '--primary-color': string;
  '--ds_buttonBrandClick': string;
  '--ds_textBrand1': string;
  '--ds_radioOn': string;
  '--ds_checkboxOn': string;
  '--ds_chipsFillSelected': string;
  '--ds_buttonBrand': string;
  '--ds_buttonBrandHover'?: string;
  '--ds_chipsFillSelectedHover'?: string;
  '--ds_textBrand2'?: string;
};

export type BaseTheme = {
  id: THEME_IDS;
  cssVariables: {
    '--progress-gradient': string;
    '--primary-color': string;
  };
  overrides?: ThemeOverrides;
};

type ThemeOverrides = {
  light?: Record<string, string>;
  dark?: Record<string, string>;
};
